"use strict";

/**
* Расширение
* 
* @class Extension
* @extends BaseObject
* @property {string} name имя расширения
* @param {string} itemSelector существующий элемент страницы
*/
(function (global) {
  var Extension = BaseObject.extend({
    init: function (data) {
      $.extend(this, data);
    },

    name: "",

    /**
    * Установить это в качестве текущего расширения
    * @method Extension#setAsCurrent
    */
    setAsCurrent: function () {
      if (WebAccess.getLocation() != "explorer") Ext_Click(this, this.name, true);
      else Ext_Click(this, this.name, false);
    },

    /**
    * Перезагрузка расширения
    * @method Extension#reload
    */
    reload: function () {
      ReloadExtension(this.name);
    }
  });
  
  global.Extension = Extension;
})(window);
